import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const requiredValidator = (message: string): ValidatorFn => {
	return (ac: AbstractControl): ValidationErrors | null => {
		const isError = Validators.required(ac);
		if (isError) return { message };
		return null;
	};
};
